import type { SelectHTMLAttributes } from "react";
import { ChevronDown } from "lucide-react";
import { cn } from "@/lib/utils";

type InlineNativeSelectProps = SelectHTMLAttributes<HTMLSelectElement> & {
  wrapperClassName?: string;
};

export function InlineNativeSelect({
  className,
  wrapperClassName,
  children,
  ...props
}: InlineNativeSelectProps) {
  return (
    <div className={cn("relative inline-flex min-w-0", wrapperClassName)}>
      <select {...props} className={cn("appearance-none pr-9", className)}>
        {children}
      </select>
      <ChevronDown className="pointer-events-none absolute right-2.5 top-1/2 h-3.5 w-3.5 -translate-y-1/2 text-muted-foreground" />
    </div>
  );
}
